import { FormControlLabel, FormControlLabelProps, Checkbox as MuiCheckBox, SxProps } from "@mui/material";
import { MouseEventHandler } from "react";

type CheckboxWithLabelProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  checked: boolean;
  label: string;
  checkboxSx?: SxProps;
} & Partial<FormControlLabelProps>;

const CheckboxWithLabel = ({ onClick, checked, label, checkboxSx, ...props }: CheckboxWithLabelProps) => {
  return (
    <FormControlLabel
      {...props}
      control={<MuiCheckBox checked={checked} onClick={onClick} sx={checkboxSx} />}
      slotProps={{
        typography: {
          variant: "body.medium.regular",
          color: "text40.main",
        },
      }}
      label={label}
      sx={{
        marginLeft: 0,
        ...props.sx,
      }}
    />
  );
};

export { CheckboxWithLabel };
